<template>
    <div class="fill-height">
        <slot></slot>
    </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import IntercomModule from "@/modules/intercom/intercom"
import AppModule from "@/store/modules/app"
import {Router} from "@/composables/Router";
import Vue from "vue";

export default {
    name: "IntercomController",
    props: {
        isMiniUku: {
            type: Boolean,
            default: true
        }
    },
    head: {
        script: function () {
            return this.intercomId ? [{
                type: 'text/javascript',
                nonce: window.uku_nonce,
                inner: `(function(){var w=window;var ic=w.Intercom;if(typeof ic==='function'){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${this.intercomId}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{l()}}})()`
            }] : []
        }
    },
    setup(props, ctx) {
        const router = Router()
        const appModule = AppModule()
        const intercomId = ref(window.uku_no_track ? '' : appModule.intercomData.value.app_id)

        const bootIntercom = () => {
            // do not load
            if (window.uku_no_track) {
                console.info('NO :: Intercom :: disabled')
                return
            }
            if (props.isMiniUku) {
                console.info('NO :: Intercom :: isMiniUku')
                return
            }

            // load
            IntercomModule.setIntercomSettings(appModule.intercomData.value)
            IntercomModule.bootIntercom(appModule.intercomData.value)
            if (ctx.root.$vuetify.breakpoint.smAndDown) {
                // hide for smaller screens
                IntercomModule.updateIntercom({"hide_default_launcher": true})
                console.info('HIDE :: Intercom')
            }
        };

        // ukuwinversion is not defined on initial load, currently wait for router to be ready and wait for next tick so it is loaded
        router.onReady(async () => {
            await Vue.nextTick()
            bootIntercom()
        })

        return {intercomId}
    }
};
</script>
